export default __webpack_public_path__ + "static/banner4-4300f846ee3cd915d5a0e4aaf781f25e.png";